import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { Button as KitButton } from '@beef/ui-kit';
import { selectButtonTexts } from "../../../../store/blocks/addressVerification/selectors";
import { selectIsLoadingFlag } from "../../../../store/blocks/addressVerification/moduleSelectors";
import { handleStepProgress } from "../../../../store/blocks/addressVerification/actions/handleStepProgress";
import { handleSecondaryButtonClick } from "../../../../store/blocks/addressVerification/actions/handleSecondaryButtonClick";
import { useButtonConfig } from "../../hooks/useButtonConfig";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _ButtonContainer = function _ButtonContainer(_ref) {
  var className = _ref.className,
    buttonText = _ref.buttonText,
    secondaryButtonText = _ref.secondaryButtonText,
    onSecondaryButtonClick = _ref.onSecondaryButtonClick,
    isLoading = _ref.isLoading,
    onClick = _ref.onClick;
  var _useButtonConfig = useButtonConfig(),
    size = _useButtonConfig.size,
    fullWidth = _useButtonConfig.fullWidth;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container', className),
    "data-t-id": "components-ButtonContainer"
  }, /*#__PURE__*/React.createElement(KitButton, {
    fullWidth: fullWidth,
    isLoading: isLoading,
    onClick: onClick,
    size: size
  }, buttonText), secondaryButtonText && /*#__PURE__*/React.createElement(KitButton, {
    fullWidth: fullWidth,
    onClick: onSecondaryButtonClick,
    size: size,
    variant: "tertiary"
  }, secondaryButtonText));
};
var mapStateTuProps = function mapStateTuProps(state) {
  var _selectButtonTexts = selectButtonTexts(state),
    buttonText = _selectButtonTexts.buttonText,
    secondaryButtonText = _selectButtonTexts.secondaryButtonText;
  return {
    isLoading: selectIsLoadingFlag(state),
    shouldRender: !!buttonText,
    secondaryButtonText: secondaryButtonText,
    buttonText: buttonText
  };
};
var mapDispatchToProps = {
  onClick: handleStepProgress,
  onSecondaryButtonClick: handleSecondaryButtonClick
};
var connector = connect(mapStateTuProps, mapDispatchToProps);
export var ButtonContainer = compose(connector, withRenderFlag)(_ButtonContainer);